// @flow
import React from 'react';
import type {Node} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import translate from '../../config/text';
import styles from './Footer.module.css';
import facebook from './icons/facebook-logo.png';
import twitter from './icons/twitter-black-shape.png';
import pinterest from './icons/pinterest-logo.png';
import instagram from './icons/instagram-logo.png';
import linkedin from './icons/linkedin-logo.png';
import world from './icons/flg/worldwide.svg';




type StatusType = {
    isLoggedIn: boolean,
};

const Footer = ({
    status,
    language,
}: {status: StatusType, language: string}): Node => {
  const t = translate(language);
  if(status.isLoggedIn === true){
      return (
          <div className={styles.footer}>
              <div className={styles.lngContainer}>
                  <div className={styles.lng}>
                      {/*{pickLanguageTitle(language)} - <Link to={'/language'}>{t('changeLanguage')}</Link>*/}
                      <Link to={'/language'}>
                          <div className={styles.lngWrapper}>
                              <img src={world} alt={'World Wide Icon'} />
                              <div className={styles.lngName}>
                                  {t('changeLanguage')}
                              </div>
                          </div>
                      </Link>

                  </div>
                  <div>
                      <ul className={styles.social}>
                          <li><a href={'http://facebook.com/cambridgeaudio' } target={"_blank"}><img src={facebook} alt="facebook" /></a></li>
                          <li><a href={'http://twitter.com/CambridgeAudio'} target={"_blank"}><img src={twitter} alt="twitter" /></a></li>
                          <li><a href={'http://pinterest.co.uk/cambridgeaudio'} target={"_blank"}><img src={pinterest} alt="pinterest" /></a></li>
                          <li><a href={'http://instagram.com/cambridgeaudio'} target={"_blank"}><img src={instagram} alt="instagram" /></a></li>
                          <li><a href={'http://linkedin.com/company/cambridge-audio'} target={"_blank"}><img src={linkedin} alt="linkedin" /></a></li>
                      </ul>
                  </div>
              </div>
          </div>
      );
  } else{
      return (
          null
      )
  }
};

const mapStateToProps = (state: any): any => ({
  language: state.status.language,
    status: state.status,
});

const FooterContainer = connect(
  mapStateToProps,
)(Footer);

export default FooterContainer;











// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js